import { baseClient } from './client/instance';

export const disconnect = async (sourcePath: string) => {
  const response = await baseClient.delete(
    `/${sourcePath}/disconnect`,
  );
  return response.data;
};
